import React from 'react';

import { Typography } from '@mui/material';
import clsx from 'clsx';
import { AlineAvatar } from 'src/components';
import { toAvatarPlaceholder } from 'src/components/AlineAvatar';
import { getRoleDisplayDetails } from 'src/helpers';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  container: {
    alignItems: 'center',
    display: 'flex',
    gap: theme.spacing(1),
    width: '100%',
  },
}));

interface AssignRolePlaceholderProps extends React.HTMLAttributes<HTMLElement> {
  rolePlaceholder: { avatarColor: string | null; roleName: string };
}

export function AssignRolePlaceholder({
  className,
  rolePlaceholder,
}: AssignRolePlaceholderProps): JSX.Element {
  const { classes } = useStyles();
  const { avatarColor, primaryText } = getRoleDisplayDetails(rolePlaceholder);

  return (
    <div className={clsx(classes.container, className)}>
      <AlineAvatar
        avatarInfo={toAvatarPlaceholder(rolePlaceholder.roleName, rolePlaceholder.avatarColor)}
        styles={{ backgroundColor: avatarColor, size: 'md' }}
      />
      <Typography variant="body1">{primaryText}</Typography>
    </div>
  );
}
